import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../modules/leadsActions'
import * as api from '../api/lead'

function* fetchLeads(action) {
  try {
    const payload = yield call(api.getLeadsList, { status: action.status })
    yield put({ type: constants.LEADS_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEADS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* leadsRefresh() {
  yield takeLatest(constants.LEADS_REFRESH.ACTION, fetchLeads)
}

function* createLead(action) {
  try {
    const payload = {
      content: action.content,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.createLead, payload)
    yield put({ type: constants.CREATE_LEAD.SUCCESS, payload })
    yield call(fetchLeads, { status: 'all' })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_LEAD.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateLead() {
  yield takeLatest(constants.CREATE_LEAD.ACTION, createLead)
}

export function* rootSaga() {
  yield all([fork(leadsRefresh), fork(watchCreateLead)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/leadsSaga.js